import { render, staticRenderFns } from "./DepublishPage.vue?vue&type=template&id=04027a20&scoped=true"
import script from "./DepublishPage.vue?vue&type=script&lang=js"
export * from "./DepublishPage.vue?vue&type=script&lang=js"
import style0 from "./DepublishPage.vue?vue&type=style&index=0&id=04027a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04027a20",
  null
  
)

export default component.exports